<template>
  <q-header
    class="bg-primary text-black q-px-lg q-py-sm row justify-center"
  >
    <div class="row no-wrap items-center justify-between col-12">
      <div class="col-shrink row content-center justify-center cursor-pointer">
        <img
          v-if="$q.screen.width > 600"
          src="../../../public/logo.svg"
          @click="gotoHome"
        >
        <img
          v-else
          class="mobileLogo q-py-xs"
          src="../../../public/mobileLogo.svg"
          @click="gotoHome"
        >
      </div>

      <div
        class="row"
        :class="{
          'col-grow justify-end': $q.screen.width < 1440,
        }"
      >
        <LayoutOpeningHours class="gt-md" />

        <div
          v-if="isOpen && products.length && !isCatering"
          class="row justify-center content-center"
          :class="{
          'q-pa-lg': $q.screen.width >= 1440,
          'q-px-sm': $q.screen.width < 1440,
        }"
        >
          <q-btn
            to="/order"
            rounded
            :flat="$q.screen.width < 1440"
            color="accent"
            :text-color="$q.screen.width < 1440 ? 'accent' : 'primary'"
            class="q-pa-xs"
          >
            <q-icon
              size="sm"
              name="mdi-cart-outline"
              class="q-mr-sm"
            />
            <q-badge
              rounded
              floating
              :color="$q.screen.width >= 1440 ? 'primary' : 'accent'"
              :text-color="$q.screen.width >= 1440 ? 'white' : 'primary'"
              class="z-top"
              :label="products.length"
            />
            <span v-if="$q.screen.width >= 1440">Pöntunin þín</span>
          </q-btn>
        </div>
      </div>

      <div
        class="lt-lg col-shrink q-pr-sm row items-center"
      >
        <q-btn
          flat
          size="lg"
          color="accent"
          icon="mdi-menu"
          class="full-height"
          @click="toggleDrawer"
        />
      </div>
    </div>
    <div class="col-12">
      <q-separator
        spaced="lg"
      />
    </div>
    <div class="row col-12 justify-center">
      <LayoutOpeningHours class="lt-lg self-center" />
      <LayoutNav class="row gt-md justify-between full-width" />
    </div>
  </q-header>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import LayoutNav from 'components/layout/Nav';
import LayoutOpeningHours from 'components/layout/OpeningHours';

export default {
  name: 'LayoutHeader',
  components: { LayoutOpeningHours, LayoutNav },

  computed: {
    ...mapState('application', ['defaultDeliveryMethod']),
    ...mapState('location', { currentLocation: 'current' }),
    ...mapState('layout', ['showDrawer']),
    ...mapState('order', ['products', 'isCatering']),

    isOpen() {
      return this.currentLocation.isOpen(this.defaultDeliveryMethod.id);
    },
  },

  methods: {
    ...mapMutations('layout', ['openDrawer', 'closeDrawer']),
    gotoHome() {
      this.$router.push({ name: 'Home' }).catch(() => {});
    },

    toggleDrawer() {
      if (this.showDrawer) {
        this.closeDrawer();
      }
      else {
        this.openDrawer();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mobileLogo {
  width: 50px;
}
.q-header {
  > div {
    max-width: 1470px;
  }
  .phoneNumber {
    font-size: 18px;
    font-weight: 600;

    @media(max-width: 600px) {
      font-size: 14px;
    }
  }

  .openingHours {
    font-size: 16px;
    font-weight: 600;
  }
  .q-badge {
    height: 16px;
    width: 16px;
    justify-content: center;
    font-size: 12px;
    position: absolute;
    top: 0;
    right: 116px;
    @media (max-width: 1440px) {
      right: 18px;
    }
  }

  &:deep(.q-separator) {
    background: rgba(255,255,255,30%)!important;
    width: 100%;
  }
}
</style>
